import { consumer } from "@bemap/utils";

export interface PublicCampaignLinkDTO {
  id: number;
  code: string;
  is_active: boolean;
  type: string;
}

export const getPublicCampaignLink = async (code: string): Promise<any> => {
  return consumer('GET', `/campaign-links/${code}`);
}

export default {
  getPublicCampaignLink,
};


